module.exports = __webpack_public_path__ + "static/media/cifar4.1b9aabd1.png";